// https://swiperjs.com/get-started
import SwiperCore, { Navigation, Pagination, Scrollbar, EffectFade } from 'swiper/core';
SwiperCore.use([Navigation, Pagination, Scrollbar, EffectFade]);
import 'swiper/swiper-bundle.css';

const blockSliderBreakpoints = {
	640: {
		slidesPerView: 2,
	},
	1280: {
		slidesPerView: 3,
	},
};

const initBlockSlider = (block) => {
	const imageSliderEl = block.querySelector('.image-slider');

	if (!imageSliderEl) {
		return;
	}

	new SwiperCore(imageSliderEl, {
		direction: 'horizontal',
		loop: true,
		slidesPerView: 1,
		loopAdditionalSlides: 2,
		navigation: {
			nextEl: imageSliderEl.querySelector('.swiper-button-next'),
			prevEl: imageSliderEl.querySelector('.swiper-button-prev'),
		},
		breakpoints: blockSliderBreakpoints,
	});
};

document.querySelectorAll('.block--slider').forEach(initBlockSlider);

const testimonialSliderEl = document.querySelector('.testimonial--slider');

if (testimonialSliderEl) {
	new SwiperCore(testimonialSliderEl, {
		direction: 'horizontal',
		loop: true,
		speed: 500,
		effect: 'fade',
		fadeEffect: {
			crossFade: true,
		},
		navigation: {
			nextEl: '.testimonial--swiper--next',
			prevEl: '.testimonial--swiper--prev',
		},
	});
}

const testimonialBlockEl = document.querySelector('.testimonial-slider');

if (testimonialBlockEl) {
	new SwiperCore(testimonialBlockEl, {
		slidesPerView: 1,
		direction: 'horizontal',
		loop: true,
		navigation: {
			nextEl: '.swiper-button-next-testimonial',
			prevEl: '.swiper-button-prev-testimonial',
		},
		pagination: {
			el: '.swiper-pagination',
			clickable: true,
		},
	});
}
